import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import './DeleteConfirmationModal.scss'

function DeleteConfirmationModal({showDeleteModal, handleClose, fileId, onDelete}: any) {
  const intl = useIntl()
  return (
    <>
      {showDeleteModal && fileId ? (
        <Modal show={showDeleteModal} onHide={handleClose} centered>
          <Modal.Body>
            <div className='mdt-links-container'>
              <div className='d-flex w-100 align-items-center justify-content-between'>
                <h1 className='d-flex gap-3 align-items-center'>
                  {intl.formatMessage({id: 'GENERAL.LABEL.DELETE_FILE'})}
                </h1>
                <button className='btn btn-link p-0' type='button' onClick={handleClose}>
                  <i
                    className='fa fa-times-thin fa-2x'
                    aria-hidden='true'
                    style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
                  ></i>
                </button>
              </div>
              <div className='d-flex gap-5 align-items-center'>
                <label className='form-label fs-6 m-0 text-gray-600'>
                  {intl.formatMessage({
                    id: 'GENERAL.LABEL.ARE_YOU_SURE_YOU_WANT_TO_PERMANENTLY_DELETE_THIS_FILE',
                  })}
                </label>
              </div>
              <div className='line-break w-100 ' style={{backgroundColor: '#EFF2F5', height: 1}} />
              <div className='actions'>
                <button className='cancel-button' type='button' onClick={handleClose}>
                  {intl.formatMessage({id: 'BUTTON.CANCEL'})}
                </button>
                <button
                  className='delete-button'
                  type='button'
                  onClick={(e) => {
                    e.stopPropagation()
                    onDelete(fileId)
                  }}
                >
                  {intl.formatMessage({id: 'GENERAL.LABEL.DELETE_FILE'})}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <></>
      )}
    </>
  )
}

export default DeleteConfirmationModal
